import dynamicImportPolyfill from './libs/dynamic-import-polyfill.m.js';

// import './libs/video.js'
// import './libs/videojs-http-streaming.js'
import './libs/webtrekk_mediaTracking.js'
import './common.js'
// import './commons/iubenda.js'
import { eventBus, EVENTS } from './commons/EventBus.js';
import router from "./commons/Router.js";
// console.log('test build 1');

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (str, newStr) {
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    }
    // If a string
    return this.replace(new RegExp(str, 'g'), newStr);
  };
}
// This needs to be done before any dynamic imports are used.
dynamicImportPolyfill.initialize({
  // modulePath: '/public', // Defaults to '.'
  importFunctionName: 'import' // Defaults to '__import__'
});

window.importJavascript = (template) => {
  let _import = new Promise((r) => { r() });
  // console.log('importJavascript1');
  console.log(template);

  // if(template=="single_post" && window.location.href.includes("scopri/eventi-rds/rds-bar-of-the-week"))
  // {
  //   window.location.href="https://www.rds.it/rds-bar-of-the-week";
  //   return;
  // }

  switch (template) {
    case 'home':
    case 'homepage':
      _import = import('./homepage.js');
      break;

    case 'profilo':
      _import = import('./profilo.js');
      break;
    case 'magazine':
    case 'magazine-category':
      _import = import('./magazine.js');
      break;

    case 'eventi':
      _import = import('./eventi.js');
      break;
    case 'palinsesto':
      _import = import('./palinsesto.js');
      break;
    case 'che_canzone_era':
      _import = import('./cce.js');
      break;
    case 'podcast_tutti_pazzi':
    case 'podcast_il_meglio_di':
    case 'podcast':
    case 'podcast_categoria':
      _import = import('./podcast.js');
      break;
    case 'playlist':
      _import = import('./musica.js');
      break;
    case 'classifiche':
    case 'dettaglio_classifica':
      _import = import('./classifiche.js');
      break;
    case 'richiedi_scherzo':
      _import = import('./richiesta_scherzo.js');
      break;
    case 'form_horeca':
      _import = import('./form_horeca.js');
      break;
    case 'form_summerfestival2023':
      _import = import('./form_summerfestival.js');
      break;
    case 'giochi':
    case 'dettaglio_gioco':
      _import = import('./giochi.js');
      break;
    case 'gioco-fan-landing':
      _import = import('./giochi-fanize.js');
      break;

     case 'login':
      _import = import('./community.js');
      break;
  /*  case 'talenttokens':
      _import = import('./talenttokens.js');
      break;*/
    case 'rds_social_tv':
      _import = import('./rds-social-tv.js');
      break;
    default:
      break;

  }
  // console.log('importJavascript2');
  return _import;
}

function htmlDecode(input) {

  // G.A. @ 16/07/2021 - correzione virgolette
  if(input) {
    input = input.replace(/"/g, "&quot;");
  }

  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}


window.replaceMetadata = (metadata) => {
  if (metadata) {
    return new Promise((resolve, reject) => {
      const pageMeta = document.querySelectorAll('meta[data-content]');
      for (let i = 0; i < pageMeta.length; i++) {
        const element = pageMeta[i];
        const metadataVar = element.getAttribute('data-content');
        element.setAttribute('content', htmlDecode(metadata[metadataVar]));
      }
      $(document).attr("title", htmlDecode(metadata['title']));
      resolve();
    }).then();
  } else {
    $(document).attr("title", "RDS 100% Grandi Successi | Ascolta la diretta RDS | RDS onAir");
    $('meta[name="description"]').append("<meta name='description' content='Ascolta la diretta radio RDS in streaming su www.rds.it.'>");
  }
};
function resizeMainContainer(){
  const navHeight=$('#sticky_nav').height();
  const mainTop=document.body.clientWidth / 12;
  if(!$('#rds-main').hasClass("main-with-skin")){
    $('#rds-main').height("");
  }else{
    $('#rds-main').height(document.body.clientHeight - navHeight - mainTop);
  }


}

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function () {

  resizeMainContainer();
});
eventBus.on(EVENTS.PLAYER_MODE_CHANGED, function () {
  resizeMainContainer();
});



importJavascript(window.currentTemplate).then(() => {
  $(document).ready(() => {
    if(document.body.clientWidth<1100){
      removeskin();
    }else{
      if($("#skinPh").children().length){
        showskin()
      }
    }
    resizeMainContainer();
    $(window).resize(
      (e)=>{
        if(document.body.clientWidth<1100){
          removeskin();
        }else{
          if($("#skinPh").children().length){
            showskin()
          }
        }
        resizeMainContainer();
      }
    );
    try {
      let data = window.initialData || { template: currentTemplate };
      $("#overlay-wait").fadeOut().addClass("initialized");
      if (data.blockrefresh) {
        window.refresh_active = false;
      } else {
        window.refresh_active = true;
      }
      eventBus.emit(EVENTS.PAGE_AFTER_RENDERING, {...data, _formServer: true});

    } catch (error) { }
    user.checkUser();
    $("#overlay-wait").fadeOut();
  });
});

$(document).on('scroll', (e) => {

  const cssVar = '--cur-scroll';
  const root = document.documentElement;
  root.style.setProperty(cssVar, $(document).scrollTop());

  const cssVarPercentuale = '--cur-scroll-perc';
  var scrollTop = $(window).scrollTop();
  var docHeight = $(document).height();
  var winHeight = $(window).height();
  var scrollPercent = ((scrollTop) / (docHeight - winHeight)) * 100;
  root.style.setProperty(cssVarPercentuale, scrollPercent);

});

// if('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('./rds-service-worker.js');
// };

window.setMyFavorite = function () {

  var utente = user.getLocalUser();

  if (utente) {

    var preferiti = utente.preferiti;

    $.each(preferiti, function (index, value) {

      var id_elem = value.element_id;
      var type = value.type;
      $(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").addClass("liked");

    });
  }

};

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
  window.setMyFavorite();
});

function popupErrore() {

  var popup_errore = "<div class='popup-errore-main'>" +
    "<div id='popup-errore-box'>" +
    "<div class='popup-errore-inside'>" +
    "<div class='x-delete popup-conferma-close'>" +
    "<img src='https://media.rds.it/web/web-site-brandnew/svg/icon-close-black.svg'>" +
    "</div>" +
    "<div class='position-center'>" +
    "<div class='img-warning'>" +
    "<img src='https://media.rds.it/web/web-site-brandnew/svg/rds-problemi-accesso.svg'>" +
    "</div>" +
    "<div class='font_36 font_34_tablet font_28_mobile sofia_font bold popup-title'>Ops, qualcosa non va</div>" +
    "<div class='popup-info font_18 sofia_font'>" +
    "<div>Quest'azione non è momentaneamente disponibile. Riprova più tardi!</div>" +
    "</div>" +
    "<div class='popup-conferma-button flex'>" +
    "<div class='popup-conferma-close font_16 bold button skew uppercase'>ok, ho capito</div>" +
    "</div>" +
    "</div>" +
    "</div>" +
    "</div>" +
    "<div class='background-overlay-grey' style='display: block'></div>" +
    "</div>"

  $("#rds-main").append(popup_errore);
  $("html").css('overflow-y', 'hidden');

  $(document).on("click", ".popup-conferma-close", function () {
    $(".popup-errore-main").remove();
    $("html").css("overflow-y", 'auto');
  });
}
window.popupErrore = popupErrore;


function richiediScherzo() {

  if (user.checkUser()) {
    router.addNavigation("/richiedi_scherzo");
  } else {
    user.checkUserLogged();
  }
}
window.richiediScherzo = richiediScherzo;



function iscrivitiGiochi() {

  if (user.checkUser()) {
    router.addNavigation("/gioca");
  } else {
    user.checkUserLogged("gioca");
  }
}
window.iscrivitiGiochi = iscrivitiGiochi;


$(document).on('click', '.rds-modal-popup-close', function () {
  $(".popup-messaggio-main").hide();
});

// $(document).click(function (e) {
//     if ($(".popup-messaggio-main").is(":visible") == true) {
//         if (e.target.id == 'rds-modal-popup') {
//             $(".popup-messaggio-main").hide();
//         }
//     }
// });

function openPopup(messaggio) {


  //TODO


  $(".popup-messaggio-main").show();
}

window.openPopup = openPopup;

$(document).ready(function(){
  $("#talentTokenFrame").on("load", function(){
    $(this).contents().on("mousedown, mouseup, click", function(){
      console.log("Click detected inside iframe.");
    });
  });
});




